import React, { useEffect, useState } from "react";
import { Education_Type, Experience_Type } from "../model";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import Loading from "../components/Loading";

const ExperiencePage: React.FC = () => {
  const [experience, setExperience] = useState<Experience_Type[]>([]);
  const [education, setEducation] = useState<Education_Type[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    onSnapshot(
      collection(db, "experience"),
      (snapshot) => {
        const data: Experience_Type[] = snapshot.docs.map(
          (doc) => doc.data() as Experience_Type
        );
        setExperience(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );

    onSnapshot(
      collection(db, "education"),
      (snapshot) => {
        const data: Education_Type[] = snapshot.docs.map(
          (doc) => doc.data() as Education_Type
        );
        setEducation(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  }, []);

  return (
    <div className="container mx-5 sm:mx-auto py-8">
      {loading && !experience.length && !education.length && <Loading />}

      {education.length && experience.length && (
        <>
          <h1 className="text-3xl font-bold mb-8">Work Experience</h1>

          {experience.map((exp, index) => (
            <div
              className="mb-8 bg-white p-5 rounded-md shadow hover:scale-[1.03] transition-all duration-500"
              key={index}
            >
              <h2 className="text-xl font-semibold mb-4">{exp.company}</h2>
              <p className="text-gray-600 mb-2">Role: {exp.role}</p>
              <p className="text-gray-600 mb-2">Responsibilities:</p>
              <ul className="list-disc ml-8">
                {exp.responsibilities.map((responsibility, index) => (
                  <li key={index}>{responsibility}</li>
                ))}
              </ul>
              <p className="text-gray-600 mb-2">Notable Achievements:</p>
              <ul className="list-disc ml-8">
                {exp.achivements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            </div>
          ))}

          <h1 className="text-3xl font-bold mb-8">Education</h1>

          {education.map((education, index) => (
            <div
              key={index}
              className="mb-8 bg-white p-5 rounded-md shadow hover:scale-[1.03] transition-all duration-500"
            >
              <h2 className="text-xl font-semibold mb-4">{education.name}</h2>
              <p className="text-gray-600 mb-2">Degree: {education.degree}</p>
              <p className="text-gray-600 mb-2">Year: {education.year}</p>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ExperiencePage;
